common.View.create('crud::datatable.RowReorder', {

    datatable: null,
    orderingRowId: null,
    pageChanged: false,

    static: {

        onDOMLoad()
        {
            this.patchDatatableRowReorder();
            this.initInstances();
        },

        initInstances()
        {
            // @ugly Wait for loading all Datatables.
            setTimeout(() =>
            {
                // No datatables found?
                if( !window.LaravelDataTables ) {
                    return false;
                }

                // Init instance for each datatable.
                for(const tableKey in window.LaravelDataTables )
                {
                    let table = window.LaravelDataTables[tableKey];

                    // Init?
                    if (table.settings()[0].oInit.rowReorder) {
                        new crud.datatable.RowReorder(table);
                    }
                }
            }, 1);
        },

        patchDatatableRowReorder()
        {
            // Patch due to Datatable is available?
            if (($.fn.DataTable || {}).RowReorder)
                $.fn.DataTable.RowReorder.prototype._cachePositions = this.patchedCachePositions;
        },

        /**
         * Cache the measurements that RowReorder needs in the mouse move handler
         * to attempt to speed things up, rather than reading from the DOM.
         *
         * @private
         */
        patchedCachePositions()
        {
            var dt = this.s.dt;

            // Frustratingly, if we add `position:relative` to the tbody, the
            // position is still relatively to the parent. So we need to adjust
            // for that
            var headerHeight = $(dt.table().node()).find('thead').outerHeight();

            // Need to pass the nodes through jQuery to get them in document order,
            // not what DataTables thinks it is, since we have been altering the
            // order
            var nodes = $.unique(dt.rows({page: 'current'}).nodes().toArray());
            var tops = $.map(nodes, function (node, i)
            {
                return $(node).position().top - headerHeight;
            });

                    var middles = $.map(tops, function (top, i)
            {
                return tops.length < i - 1 ?
                    (top + tops[i + 1]) / 2 :
                    (top + top + $(nodes[nodes.length - 1]).outerHeight()) / 2;
            });

            this.s.middles = middles;
            this.s.bodyTop = $(dt.table().body()).offset().top;
            this.s.windowHeight = $(window).height();
            this.s.documentOuterHeight = $(document).outerHeight();
        }
    },

    RowReorder(datatable)
    {
        // Set
        this.datatable = datatable;

        // Init row ordering.
        this.initRowOrdering();
    },

    initRowOrdering()
    {
        // Listen for reordering.
        this.datatable.on('pre-row-reorder', this.onPreRowReorder.bind(this));

        // Listen for reordered.
        this.datatable.on('row-reorder', this.onRowReorder.bind(this));

        // Listen for drop reorder
        this.datatable.on('mouseup.rowReorder touchend.rowReorder', this.onRowReorderMouseUp.bind(this));

        // Listen for page changed.
        this.datatable.on('draw', this.onDatatableDraw.bind(this));
    },

    onRowReorderMouseUp()
    {
        // Item being dragged to a different page and being saved there?
        // Since yajra datatables gives an error on row-reorder we save the item on mouse drop
        if( this.pageChanged ) {
            this.onRowReorder();
        }
    },

    onPreRowReorder(e, node)
    {
        // Set current row.
        this.orderingRowId = this.datatable.row(node.index).data().id;

        // Disable pointer events on dragged row so we can hover on pagination links.
        setTimeout(() => $('.dt-rowReorder-float-parent').css('pointer-events', 'none'), 1);

        this.initPaginationHovering();
    },

    onRowReorder()
    {
        var element = $(this.datatable.containers()[0]);

        // Get element of the dragged element, on this page.
        var rowInCurrentPage = element.find('tr#' + this.orderingRowId);

        // Get sibling rows.
        var siblingRows = [
            $(rowInCurrentPage).prev(),
            $(rowInCurrentPage).next()
        ];

        // Construct data.
        var data = {
            changedId: this.orderingRowId,
            sibling: {
                id: siblingRows[siblingRows[0].length ? 0 : 1].attr('id'),
                position: siblingRows[0].length ? 'after' : 'before'
            }
        };

        // Clear
        this.orderingRowId = null;

        // Set as loading.
        this.setLoading(true);

        var locationUrl = window.location.href.split('?')[0];
        var getParameters = window.location.href.split('?')[1] ?? '';

        // Request
        $.post(locationUrl + '/set-order?' + getParameters, data, () =>
        {
            // Reload
            this.datatable.ajax.reload(() => this.setLoading(false), false);
        });

        // Reset page changed
        this.pageChanged = false;
    },

    setLoading(value)
    {
        $(this.datatable.containers()[0]).toggleClass('loading', value);
    },

    initPaginationHovering()
    {
        var timeout;

        // Listen for mouse hover on pagination.
        $(this.datatable.containers()[0])

            // Listen mouse over.
            .on('mouseover', '#dataTableBuilder_paginate a', event =>
            {
                // Abort due to not relevant anymore?
                if (!this.orderingRowId)
                    return;

                // Init timer.
                timeout = window.setTimeout(() =>
                {
                    // Forget current position of dragged row since we will navigate to another page.
                    this.datatable.settings()[0].rowreorder.s.lastInsert = null;

                    // Go to page.
                    $(event.currentTarget).trigger('click');
                    this.pageChanged = true;
                }, 500);
            })

            // Listen for mouse out.
            .on('mouseout', '#dataTableBuilder_paginate a', event =>
            {
                // Stop timeout?
                if (timeout) {
                    window.clearTimeout(timeout);

                    timeout = null;
                }
            });
    },

    onDatatableDraw()
    {
        // Add CSS class, if not already there.
        $(this.datatable.containers()[0]).addClass('hasRowReordering');

        // Abort due to not dragging an row?
        if (this.orderingRowId === null)
            return true;

        // Get row.
        var row = this.datatable.row('#' + this.orderingRowId);

        if (row) {
            $(this.datatable.containers()[0]).find('tr #' + this.orderingRowId).remove();
        }

        return true;
    }

});
